import type { AccountNode, GroupNode } from './forecast'

export type EventProperties = Record<string, string | number | boolean | null>

export function trackForecastEvent(
  action: string,
  properties: EventProperties = {}
): void {
  window.heap?.track(`Forecast: ${action}`, properties)
}

export function nodeLevel(node: AccountNode | GroupNode): 'account' | 'group' {
  return node.type === 'Account' ? 'account' : 'group'
}

export function adjustmentType(
  fromQuickButton: boolean,
  expression: string | null
): 'quick_percentage' | 'percentage_expression' | 'expression' | 'value' {
  if (fromQuickButton) return 'quick_percentage'
  if (expression?.includes('%')) return 'percentage_expression'
  if (expression && /[+\-*/]/.test(expression.trim().replace(/^[+-]/, '')))
    return 'expression'
  return 'value'
}
